import { render, staticRenderFns } from "./NavbarBlocked.vue?vue&type=template&id=8ff58490&"
import script from "./NavbarBlocked.vue?vue&type=script&lang=js&"
export * from "./NavbarBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavbarBlocked.vue"
export default component.exports